interface TenantRoleTooltipProps {
  active?: boolean;
  x?: number;
  y?: number;
}

const TenantRoleTooltip: React.FC<TenantRoleTooltipProps> = (props) => {
  const { active, x, y } = props;
  return (
    <div
      className={`${active ? 'absolute z-[9999] w-[700px] rounded-md border border-gray-200 bg-white p-3' : 'hidden'}`}
      style={{
        top: `${active && y ? `${y}px` : undefined}`,
        left: `${active && x ? `${x}px` : undefined}`,
      }}
    >
      <p className='mb-1 text-sm font-bold'>テナント管理者</p>
      <p className='mb-2 text-sm'>
        利用可能機能：金融機関向けのすべての機能(テナントユーザーの権限管理、DX診断結果の閲覧、記事・イベント・支援サービスの作成・削除)、オンラインコミュニティの設定・投稿削除・ユーザー管理・分析ダッシュボード・投稿・閲覧
      </p>
      <p className='mb-1 text-sm font-bold'>コンテンツ編集者</p>
      <p className='mb-2 text-sm'>
        利用可能機能：DX診断結果の閲覧、記事・イベント・支援サービスの作成・削除、オンラインコミュニティの投稿・閲覧
      </p>
      <p className='mb-1 text-sm font-bold'>テナントメンバー</p>
      <p className='mb-2 text-sm'>
        利用可能機能：個人プロフィールの変更、オンラインコミュニティの投稿・閲覧
      </p>
      <p className='text-sm'>
        利用可能機能については、ご契約内容により異なる場合があります。詳細はご契約内容をご確認ください
      </p>
    </div>
  );
};

export default TenantRoleTooltip;
